import { render } from "./TypingEffect.vue?vue&type=template&id=f929d4ac&scoped=true"
import script from "./TypingEffect.vue?vue&type=script&lang=js"
export * from "./TypingEffect.vue?vue&type=script&lang=js"

import "./TypingEffect.vue?vue&type=style&index=0&id=f929d4ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f929d4ac"]])

export default __exports__